import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal, Divider, Row, Col } from '_zari/core'

import * as ProductoCrud from 'services/producto.service'

import FileFormGroup from './formGroups/file'

import { DownloadAxiosFile } from 'utils'

const ImportarRegistrosModal = ({ handleClose, show }) => {
  const __zariContext = React.useContext(ZariContext)
  const formInitialValues = React.useMemo(
    () => ({
      file: ''
    }),
    []
  )

  const submitHandler = data => {
    __zariContext.loader.open('Importando registros')

    const submitData = new FormData()
    submitData.append('file', data.file)

    ProductoCrud.importarExcelPrecios(submitData)
      .then(() => {
        __zariContext.snack('success', `Los datos se han importado correctamente`)
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }

  const clickDescargarPlantilla = React.useCallback(() => {
    ProductoCrud.descargarPlantillaImportarPrecios().then(({ data, headers }) => {
      DownloadAxiosFile.downloadAsBlob(data, headers, 'Importar precios.xlsx')
    })
  }, [])


  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>IMPORTAR EXCEL</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
          <Form>
            <Modal.Body>
            <Row>
                <Col md={12}>
                  <Button outline block onClick={clickDescargarPlantilla}>
                    Descargar plantilla
                  </Button>
                </Col>
              </Row>
              <Divider />
              <FileFormGroup
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
                iError={errors.file}
                iTouched={touched.file}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Importar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default ImportarRegistrosModal
